import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], term: any[]): any {
    return term.length!=0 ? items.filter(item=>{ return _.intersection(term ,item["codeActivitePortuaire"]).length }): items;
  }

}
